import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import VideoListPage from './pages/VideoListPage';
import VideoDetailPage from './pages/VideoDetailPage';
import SettingsPage from './pages/SettingsPage';
import SessionManagementPage from './pages/SessionManagementPage';
import EventLogPage from './pages/EventLogPage';
import NotFoundPage from './pages/NotFoundPage'; // Optional
import StorageStatusCheck from './components/StorageStatusCheck';
import AdminLoginModal from './components/AdminLoginModal';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LanguageProvider, useLanguage, useT } from './utils/i18n';
import './App.css';

// Thai by default, English once the admin logs in. The switch is a temporary
// override — a reload or a login/logout puts it back to the role default — so it
// reads as "preview the other view", which is what it is used for.
function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const t = useT();
  return (
    <div className="btn-group btn-group-sm me-2" role="group" aria-label={t('Display language')}>
      {['th', 'en'].map((code) => (
        <button
          key={code}
          type="button"
          className={`btn ${language === code ? 'btn-secondary' : 'btn-outline-secondary'}`}
          aria-pressed={language === code}
          onClick={() => setLanguage(code)}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

function AdminNav() {
  const { isAdmin, logout } = useAuth();
  const [showLogin, setShowLogin] = useState(false);

  return (
    <>
      <div className="ms-auto d-flex align-items-center">
        <LanguageSwitcher />
        {isAdmin ? (
          <>
            <Link className="nav-link" to="/sessions">🎚️ Sessions</Link>
            <Link className="nav-link" to="/logs">📋 Logs</Link>
            <Link className="nav-link" to="/settings">⚙️ Settings</Link>
            <span className="badge bg-success mx-2">Admin</span>
            <button className="btn btn-sm btn-outline-secondary" onClick={logout}>Log out</button>
          </>
        ) : (
          <button className="btn btn-sm btn-outline-secondary" onClick={() => setShowLogin(true)}>
            Admin login
          </button>
        )}
      </div>
      <AdminLoginModal show={showLogin} onHide={() => setShowLogin(false)} />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <Router>
          <div className="App">
            <nav className="navbar navbar-expand-lg navbar-light bg-light mb-4">
              <div className="container-fluid">
                <Link className="navbar-brand" to="/">AD Recorder</Link>
                <AdminNav />
              </div>
            </nav>

            <div className="container">
              <StorageStatusCheck />
            </div>

            <Routes>
              <Route path="/" element={<VideoListPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/sessions" element={<SessionManagementPage />} />
              <Route path="/logs" element={<EventLogPage />} />
              <Route path="/videos/:videoId" element={<VideoDetailPage />} />
              <Route path="*" element={<NotFoundPage />} /> {/* Catch-all for 404 */}
            </Routes>
          </div>
        </Router>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
